export enum BulkEditChangeTypeEnum {
  ADD = 'ADD',
  REVERT = 'REVERT',
  MODIFY = 'MODIFY',
  UNCHANGED = 'UNCHANGED'
}
